
import { Bot } from "lucide-react";
import { Progress } from "@/components/ui/progress";

interface RecipeProcessingStatusProps {
  isLoading: boolean;
  processingStage: string;
  progress: number;
}

const RecipeProcessingStatus = ({ isLoading, processingStage, progress }: RecipeProcessingStatusProps) => {
  if (!isLoading) return null;

  return (
    <div className="mt-4 p-4 bg-muted rounded-md">
      <div className="flex items-center gap-2 mb-2">
        <Bot size={18} className="animate-pulse text-primary" />
        <p className="font-medium text-sm">{processingStage}</p>
      </div>
      <div className="space-y-2 mt-3">
        <Progress value={progress} className="h-2" />
        <p className="text-xs text-center text-muted-foreground">
          {progress < 30 ? 'Analyzing page structure...' : 
           progress < 60 ? 'Extracting recipe details...' : 
           progress < 90 ? 'Formatting data...' : 'Almost done...'}
        </p>
      </div>
      <p className="text-xs text-muted-foreground mt-4">
        Please be patient while we extract the recipe details. This process typically takes 10-30 seconds.
      </p>
    </div>
  );
};

export default RecipeProcessingStatus;
